import { useSelector } from 'react-redux';

import ProductCard from 'components/common/ProductCard';
import { ProductDetailCarousel } from 'components/productdetail/ProductDetailCarousel';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import useMartyContext from 'hooks/useMartyContext';
import type { AppState } from 'types/app';
import type { HeartProps } from 'types/hearts';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/components/productdetail/recos.scss';

interface AmazonReverseSharingCarouselProps {
  heartsData: HeartProps;
}

export const AmazonReverseSharingCarouselContent = ({ heartsData }: AmazonReverseSharingCarouselProps) => {
  const { testId } = useMartyContext();
  const { data, isLoading } = useSelector((state: AppState) => state.amazonReverseSharing);

  if (isLoading || !data || !data.linkedStyles?.length) {
    return null;
  }

  const productCards = data.linkedStyles.map((style, index) => (
    <ProductCard
      key={`amazon-reverse-${style.styleId}-${index}`}
      index={index}
      brandName={style.brandName}
      productName={style.productName}
      productId={style.productId}
      styleId={style.styleId}
      productUrl={style.productUrl}
      productSeoUrl={style.productSeoUrl}
      imageId={style.imageId}
      msaImageId={style.msaImageId}
      price={style.price}
      originalPrice={style.originalPrice}
      percentOff={style.percentOff}
      onHand={style.onHand}
      hearts={heartsData}
      data-test-id={testId('amazonReverseSharingReco')}
      badges={[]}
      includeSwatchRowSpace={true}
      isMobileBlockLayout
    />
  ));

  return (
    <div className={css.carouselContainer} data-test-id={testId('amazonReverseSharingCarousel')}>
      <ProductDetailCarousel title="Frequently Bought Together" slides={productCards} />
    </div>
  );
};

export default withErrorBoundary('AmazonReverseSharingCarousel', AmazonReverseSharingCarouselContent);
